import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thumbnail',
  standalone: false,
})
export class ThumbnailPipe implements PipeTransform {
  constructor() {}

  transform(media, args?): string {
    const thumbMedia =
      media.find((response) => response.type === 'THUMB_MEDIA') ||
      media.find((response) => response.type === 'IMAGE_MEDIA');
    return thumbMedia?.url || '';
  }
}
